import React, { forwardRef, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import * as icons from 'react-bootstrap-icons';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import Payments from './Payments';
import Statuses from './Statuses';
import { TextShow } from 'Utils/Helpers/TextShow';
import { setOpenStatusHistory } from '../../../../../../Redux/slices/globalSlice';
import ActionButton from 'Utils/Helpers/ActionButton';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AppointmentHistory({ data, patient }) {
    const dispatch = useDispatch();
    const [show, setShow] = useState(false);
    const [value, setValue] = useState('1');
    const { openStatusHistory, current } = useSelector((state) => ({
        openStatusHistory: state.setting.openStatusHistory,
        current: state.staff.current,
    }));

    useEffect(() => {
        if(openStatusHistory.open) {
            setValue(openStatusHistory.tab);
            setShow(true);
            dispatch(setOpenStatusHistory({ open: false, tab: '1' }));
        }
    },[openStatusHistory.open])

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const setShowDialog = () => {
        setShow(true);
    }

    const handleClose= () => {
        setShow(false);
    }

    return (
        <>
            <ActionButton
                icon={<icons.ClockHistory/>}
                onClick={setShowDialog}
                disabled={!current[1][2]}
                hidden={!current[1][2]}
            />
            {
                show &&
                <Dialog
                    open={show}
                    TransitionComponent={Transition}
                    keepMounted
                    fullWidth={true}
                    maxWidth={'md'}
                    // TransitionProps={{onEnter: onEnter}}
                    onClose={handleClose}
                    aria-describedby="alert-dialog-slide-appointment-edit"
                >
                    <DialogTitle>
                        {`سابقه‌ها`}
                        <div className='close-btn' onClick={handleClose}>
                            <icons.X/>
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        <div className='w-100'>
                            <div className='flex-row-center-center mb-2'>
                                <TextShow
                                    title={'بیمار :'}
                                    data={data.name}
                                    className2={'fw-bold'}
                                />
                                <p className='px-3'>|</p>
                                <TextShow
                                    title={'تاریخ نوبت :'}
                                    data={data.date}
                                    className2={'fw-bold'}
                                />
                            </div>
                            <TabContext value={value}>
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <TabList onChange={handleChange} aria-label="lab API tabs patient">
                                        <Tab label={<span><icons.ArrowLeftRight size={20} className='ms-2'/>{`وضعیت (${data.statusList.length})`}</span>} value="1" />
                                        <Tab label={<span><icons.CurrencyDollar size={20} className='ms-2'/>{`پرداخت (${data.paymentList.length})`}</span>} value="2" />
                                    </TabList>
                                </Box>
                                <TabPanel value="1">
                                    <Statuses data={data} close={handleClose} patient={patient} />
                                </TabPanel>
                                <TabPanel value="2">
                                    <Payments data={data} close={handleClose} patient={patient} />
                                </TabPanel>
                            </TabContext>
                        </div>
                    </DialogContent>
                </Dialog>
            }
        </>
    );
}
